<template>
  <div class="main-slide main-slide_other_page">
    <main-slide-image-slot
      :img_src="get_img_src"
      :lazy_img_src="get_lazy_img_src"
      class="main-slide__block">
      <div v-if="add_shadow"
           class="main-slide__shadow"/>
      <div
        v-if="fill_slide"
        class="main-slide__fill main-slide__fill-semicircle">
        <component
          :is="`${getIsMobile ? 'semicircle' : fill_slide}-icon`"
        />
      </div>
    </main-slide-image-slot>
    <div class="container main-slide_other_page__container"
      :class="[!attach_form && !title? 'empty' : '', slide_height_min_height]">
      <default-title
        v-if="title"
        white
        :upper_case="title_uppercase"
        :title="title"
        :title_tag="title_tag"/>
<!--      <inline-form-with-voice-search-->
<!--        v-if="attach_form"-->
<!--        class="main-slide_other_page__form"-->
<!--      />-->
    </div>
  </div>
</template>

<script>
import MainSlideImageSlot from "../slots/MainSlideImageSlot.vue";
import DefaultButton from "../slots/DefaultButton.vue";
import SemicircleIcon from "../fill_svg/SemicircleIcon.vue";
import WaveIcon from "../fill_svg/WaveIcon.vue";
import WaveSmallerIcon from "../fill_svg/WaveSmallerIcon.vue";
import DefaultTitle from "../small_parts/DefaultTitle.vue";
import {mapGetters} from "vuex";

export default {
  name: "MainSlideOtherPages",
  components: {
    DefaultTitle,
    DefaultButton,
    MainSlideImageSlot,
    SemicircleIcon,
    WaveIcon,
    WaveSmallerIcon,
  },
  props: {
    /**props**/
    img_src: {
      type: String,
      default: '/images/uploads-main-slide.jpeg',
      admin_type: 'image',
    },
    lazy_img_src: {
      type: String,
      default: '',
      admin_type: 'image',
    },
    img_src_mobile: {
      type: String,
      default: '',
      admin_type: 'image',
    },
    lazy_img_src_mobile: {
      type: String,
      default: '',
      admin_type: 'image',
    },
    title: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    title_uppercase: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox'
    },
    title_tag: {
      type: String,
      default: 'h1',
      admin_type: 'select',
      admin_data_values: [
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6'
      ],
    },
    add_shadow: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    attach_form: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    fill_slide: {
      type: String,
      default: '',
      admin_type: 'select',
      allow_deselect: true,
      admin_data_values: [
        'wave',
        'wave-smaller',
        'semicircle'
      ],
    },
    slide_height_min_height: {
      type: String,
      default: '',
      admin_type: 'select',
      allow_deselect: true,
      admin_data_values: [
        'min_height-300',
        'min_height-350',
        'min_height-500'
      ],
    },
    /**props**/
  },
  computed: {
    ...mapGetters([
      'getIsMobile'
    ]),
    get_img_src() {
      if (!this.getIsMobile) return this.img_src
      return this.img_src_mobile ? this.img_src_mobile : this.img_src
    },
    get_lazy_img_src() {
      if (!this.getIsMobile) return this.lazy_img_src
      return this.lazy_img_src_mobile ? this.lazy_img_src_mobile : this.lazy_img_src
    }
  }
}
</script>
